module.exports = __webpack_public_path__ + "static/media/newpic.0a8a5228.png";